export default __webpack_public_path__ + "static/media/chartres8.9ef4f744.jpg";